import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { Agency } from '../interfaces/Agency';
import { ConsolidatorsResponseDTO } from '@modules/auth/interfaces/consolidator.response.dto';

@Injectable({
  providedIn: 'root',
})
export class AgenciesService {
  baseUrl: string = environment.apiUrl;

  constructor(private http: HttpClient) {}
  getAgencies(params: any): Observable<Array<Agency>> {
    return this.http.get<Array<Agency>>(this.baseUrl + '/agencies/list', {
      params: params,
    });
  }

  getConsolidators(agencyId: string): Observable<ConsolidatorsResponseDTO> {
    return this.http.get<ConsolidatorsResponseDTO>(
      this.baseUrl + `/agencies/${agencyId}/consolidators`
    );
  }
}
